import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../request.js";
import { throwIfAborted as s } from "../../core/promiseUtils.js";
import { urlToObject as t } from "../../core/urlUtils.js";
import { Version as o } from "../../core/Version.js";
import { property as i } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as p } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import l from "../../geometry/Extent.js";
import n from "../../geometry/SpatialReference.js";
import { id as u, popupEnabled as c } from "../support/commonProperties.js";

var y = function y(_y2) {
  var m = /*#__PURE__*/function (_y) {
    _inherits(m, _y);

    var _super = _createSuper(m);

    function m() {
      var _this;

      _classCallCheck(this, m);

      _this = _super.apply(this, arguments), _this.capabilities = void 0, _this.copyright = null, _this.fullExtent = null, _this.legendEnabled = !0, _this.spatialReference = null, _this.version = null;
      return _this;
    }

    _createClass(m, [{
      key: "readCapabilities",
      value: function readCapabilities(e, r) {
        var s = r.capabilities && r.capabilities.split(",").map(function (e) {
          return e.toLowerCase().trim();
        });
        if (!s) return {
          operations: {
            supportsQuery: !1,
            supportsExportMap: !1,
            supportsExportTiles: !1,
            supportsTileMap: !1
          },
          exportMap: null,
          exportTiles: null
        };

        var t = this.type,
            i = -1 !== s.indexOf("query"),
            p = -1 !== s.indexOf("map"),
            a = !!r.exportTilesAllowed,
            l = -1 !== s.indexOf("tilemap"),
            n = "tile" !== t && !!r.supportsDynamicLayers,
            u = "tile" !== t && (!r.tileInfo || n),
            c = "tile" !== t && (!r.tileInfo || n),
            y = "tile" !== t,
            _m = !!r.cimVersion && o.parse(r.cimVersion).since(1, 4);

        return {
          operations: {
            supportsQuery: i,
            supportsExportMap: p,
            supportsExportTiles: a,
            supportsTileMap: l
          },
          exportMap: p ? {
            supportsArcadeExpressionForLabeling: _m,
            supportsSublayersChanges: y,
            supportsDynamicLayers: n,
            supportsSublayerVisibility: u,
            supportsSublayerDefinitionExpression: c
          } : null,
          exportTiles: a ? {
            maxExportTilesCount: +r.maxExportTilesCount
          } : null
        };
      }
    }, {
      key: "readVersion",
      value: function readVersion(e, r) {
        var s = r.currentVersion;
        return s || (s = r.hasOwnProperty("capabilities") || r.hasOwnProperty("tables") ? 10 : r.hasOwnProperty("supportedImageFormatTypes") ? 9.31 : 9.3), s;
      }
    }, {
      key: "fetchSublayerInfo",
      value: function () {
        var _fetchSublayerInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, r) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.fetchAllLayersAndTables(r);

                case 2:
                  return _context.abrupt("return", this._allLayersAndTablesMap.get(e));

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function fetchSublayerInfo(_x, _x2) {
          return _fetchSublayerInfo.apply(this, arguments);
        }

        return fetchSublayerInfo;
      }()
    }, {
      key: "fetchAllLayersAndTables",
      value: function () {
        var _fetchAllLayersAndTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
          var _this2 = this;

          var o;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.load(e);

                case 2:
                  this._allLayersAndTablesPromise || (this._allLayersAndTablesPromise = r(t(this.url).path + "/layers", {
                    responseType: "json",
                    query: _objectSpread(_objectSpread({
                      f: "json"
                    }, this.customParameters), {}, {
                      token: this.apiKey
                    })
                  }).then(function (e) {
                    _this2._allLayersAndTablesMap = new Map();

                    var _iterator = _createForOfIteratorHelper(e.data.layers),
                        _step;

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var _r = _step.value;

                        _this2._allLayersAndTablesMap.set(_r.id, _r);
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }

                    return {
                      result: e.data
                    };
                  }, function (e) {
                    return {
                      error: e
                    };
                  }));
                  _context2.next = 5;
                  return this._allLayersAndTablesPromise;

                case 5:
                  o = _context2.sent;

                  if (!(s(e), "result" in o)) {
                    _context2.next = 8;
                    break;
                  }

                  return _context2.abrupt("return", o.result);

                case 8:
                  throw o.error;

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function fetchAllLayersAndTables(_x3) {
          return _fetchAllLayersAndTables.apply(this, arguments);
        }

        return fetchAllLayersAndTables;
      }()
    }]);

    return m;
  }(_y2);

  return e([i({
    readOnly: !0
  })], m.prototype, "capabilities", void 0), e([p("service", "capabilities", ["capabilities", "exportTilesAllowed", "maxExportTilesCount", "supportsDynamicLayers", "tileInfo"])], m.prototype, "readCapabilities", null), e([i({
    json: {
      read: {
        source: "copyrightText"
      }
    }
  })], m.prototype, "copyright", void 0), e([i({
    type: l
  })], m.prototype, "fullExtent", void 0), e([i(u)], m.prototype, "id", void 0), e([i({
    type: Boolean,
    json: {
      origins: {
        service: {
          read: {
            enabled: !1
          }
        }
      },
      read: {
        source: "showLegend"
      },
      write: {
        target: "showLegend"
      }
    }
  })], m.prototype, "legendEnabled", void 0), e([i(c)], m.prototype, "popupEnabled", void 0), e([i({
    type: n
  })], m.prototype, "spatialReference", void 0), e([i()], m.prototype, "version", void 0), e([p("version", ["currentVersion", "capabilities", "tables", "supportedImageFormatTypes"])], m.prototype, "readVersion", null), m = e([a("esri.layers.mixins.ArcGISMapService")], m), m;
};

export { y as ArcGISMapService };